import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType, DailyBudgetPlan } from 'core/rtbCampaign/RtbCampaign';
import { AbstractDisplayFormModel } from './DisplayFormModel';
export interface SiteWideRecommendedFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}

abstract class AbstractSiteWideRecommendedFormModel extends AbstractDisplayFormModel {
  override get campaignAdType (): AdType {
    return AdType.SITE_WIDE_RECOMMENDED;
  }
}

export class EditSiteWideRecommendedFormModel extends AbstractSiteWideRecommendedFormModel {
  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan (): boolean {
    return false;
  }
  get canEditPriceModel (): boolean {
    return false;
  }
}

export class CreateSiteWideRecommendedFormModel extends AbstractSiteWideRecommendedFormModel {

  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
    this.modelDailyBudgetType = DailyBudgetPlan.DAILY;
  }
  get canEditBudgetPlan (): boolean {
    return true;
  }
  get canEditPriceModel (): boolean {
    return true;
  }
}
